import { Divider } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useDispatch } from "react-redux";
import CreateEditForm from "../components/finalForm/CreateEditForm";
import RffAddressEditingField from "../components/finalForm/inputs/RffAddressEditingField";
import RffDateField from "../components/finalForm/inputs/RffDateField";
import RffDollarField from "../components/finalForm/inputs/RffDollarField";
import RffPercentField from "../components/finalForm/inputs/RffPercentField";
import RffSelectField from "../components/finalForm/inputs/RffSelectField";
import RffGroup from "../components/finalForm/shared/RffGroup";
import Flx from "../components/layout/Flx";

import { useBorrowerPortalHook } from "../hooks/useBorrowerPortalHook";
import { isNil } from "lodash";
import { useMemo } from "react";
import { useFormState } from "react-final-form";

const AddEditBorrowerExperienceRecordForm = ({
  borrowerId,
  initialValues,
  onSuccessFn,
}) => {
  console.log("initialValues", initialValues);
  const { loading, createExperienceRecord, updateExperienceRecord } =
    useBorrowerPortalHook();

  const isEditing = useMemo(() => {
    if (isNil(initialValues)) {
      return false;
    }
    return true;
  }, [initialValues]);

  const onCreate = (formData) => {
    let data = { ...formData };

    // console.log("onCreate", { data });
    // return;
    createExperienceRecord({
      data: data,
      borrowerId,
      onSuccessFn: onSuccessFn,
    });
  };

  const onUpdate = (formData) => {
    // dispatch(profileClear());
    // console.log("onUpdate", { entityId: initialValues?._id, formData });
    // return;
    updateExperienceRecord({
      data: formData,
      recordId: initialValues?._id,
      borrowerId,
      onSuccessFn,
    });
  };

  if (isEditing) {
    return (
      <CreateEditForm
        onUpdate={onUpdate}
        loading={loading}
        // formSpy
        initialValues={initialValues}
        updateButtonText="Update Record"
      >
        <CreateBorrowerExperienceRecordFormQuestions />
      </CreateEditForm>
    );
  }
  return (
    <CreateEditForm
      onCreate={onCreate}
      loading={loading}
      createButtonText="Create Record"
    >
      <CreateBorrowerExperienceRecordFormQuestions />
    </CreateEditForm>
  );
};

const CreateBorrowerExperienceRecordFormQuestions = ({ disabled }) => {
  const experienceTypeOptions = [
    { label: "Fix and Flip", value: "Fix and Flip" },
    { label: "Ground Up Construction", value: "Ground Up Construction" },
    { label: "Rental", value: "Rental" },
    { label: "Multifamily", value: "Multifamily" },
    { label: "Commercial", value: "Commercial" },
    { label: "Other", value: "Other" },
  ];

  // Resolution status options
  const resolutionStatusOptions = [
    { label: "In Progress", value: "In Progress" },
    { label: "Sold", value: "Sold" },
    { label: "Retained as Rental", value: "Retained as Rental" },
    // { label: "On the market for sale", value: "On the market for sale" },
  ];
  const { values } = useFormState();
  return (
    <Flx column g={4}>
      <RffGroup groupLabel="Experience Details" suppressBottomMargin>
        <RffAddressEditingField
          label={"Property Address"}
          name={"propertyAddress"}
        />
        <RffSelectField
          name="experienceType"
          label="Experience Type"
          size={6}
          options={experienceTypeOptions}
          required
        />
        <RffSelectField
          name="resolutionStatus"
          label="Resolution Status"
          size={6}
          options={resolutionStatusOptions}
          required
        />
        <RffDollarField
          name="propertyRenovationBudget"
          label="Renovation Budget"
          helperText="Total renovation budget for the property/project"
        />
      </RffGroup>

      {values?.resolutionStatus === "Sold" && (
        <>
          <Divider sx={{ my: 2, borderColor: grey[200] }} />
          <RffGroup
            groupLabel="Property Sale Information"
            suppressBottomMargin
            description="Complete this section if the property has been sold or is on the market"
          >
            <RffDateField name="propertySaleDate" label="Sale Date" size={6} />
            <RffDollarField
              name="propertySalePrice"
              label="Sale Price"
              size={6}
            />
          </RffGroup>
        </>
      )}

      <Divider sx={{ my: 2, borderColor: grey[200] }} />

      <RffGroup
        groupLabel="Entity Association"
        suppressBottomMargin
        description="Link this experience to an entity if applicable"
      >
        <RffPercentField
          name="borrowerEntityMembershipPercent"
          label="Your Ownership Percentage in Entity"
          helperText="What percentage of the entity do you own?"
        />
      </RffGroup>
    </Flx>
  );
};

const LinkedEntitySelector = ({ children }) => {
  "linkedEntity";
  return <>{children}</>;
};

export default AddEditBorrowerExperienceRecordForm;
